import { render, staticRenderFns } from "./ViewHoldTicketPage.vue?vue&type=template&id=0545f270&scoped=true&"
import script from "./ViewHoldTicketPage.vue?vue&type=script&lang=ts&"
export * from "./ViewHoldTicketPage.vue?vue&type=script&lang=ts&"
import style0 from "./ViewHoldTicketPage.vue?vue&type=style&index=0&id=0545f270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0545f270",
  null
  
)

export default component.exports